import { render } from "./TextMenu.vue?vue&type=template&id=356cc396&scoped=true"
import script from "./TextMenu.vue?vue&type=script&lang=js"
export * from "./TextMenu.vue?vue&type=script&lang=js"

import "./TextMenu.vue?vue&type=style&index=0&id=356cc396&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356cc396"]])

export default __exports__